module.exports = __webpack_public_path__ + "static/media/logo_white.0b8b2500.svg";